export default __webpack_public_path__ + "static/media/RafikiIcon.0685d020.png";